var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M29.9 18L17.8 30.1l-5.7 1.7 1.7-5.6 12.1-12.1M29.2 10.7l4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSimple);
export default __webpack_public_path__ + "static/media/editSimple.6fb4b91cec8df1efafbe213cd050457e.svg";
export { ForwardRef as ReactComponent };